var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4994 58.6705C43.5249 47.57 55.1133 43.0566 55.1133 43.0566C55.1133 43.0566 39.4994 46.8381 39.4994 54.767C39.4994 46.8381 23.8856 43.0566 23.8856 43.0566C23.8856 43.0566 34.6201 47.3261 39.4994 58.6705Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5007 18.1706L39.5007 56.7173L40.4766 53.0808L39.5007 18.1706Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5003 18.1706L39.5003 56.7173L38.5244 53.0808L39.5003 18.1706Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 38.5,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBottom);
export default __webpack_public_path__ + "static/media/button-bottom.f22d229eb71dd67f4e8c18f6a062e8b0.svg";
export { ForwardRef as ReactComponent };